module.exports = __webpack_public_path__ + "media/SetA_L5_A.3cd27d49.mp3";